module.exports = __webpack_public_path__ + "static/media/036-greta alberta.1978d98b.jpg";